const Footer = () => {


  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=League+Spartan:wght@100..900&display=swap');

        .league-spartan {
          font-family: 'League Spartan', sans-serif;
        }
      `}</style>

      <footer className="border-t dark:bg-gray-900 league-spartan dark:border-gray-700">
        <div className="container mx-auto px-4 py-8">
          <div className="space-y-8">
            {/* Logo and Subscribe Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="text-2xl font-bold text-[#FF3366] flex items-center">
                 <img src="https://app.thenewscc.com.br/logo_waffle.png" alt="Logo" className="w-20 rounded-lg" />
                </div>
                <p className="text-gray-600 dark:text-gray-400">
                  do not follow,<br />
                  consume it.
                </p>
              </div>
            </div>

            {/* Copyright */}
            <div className=" border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                © {new Date().getFullYear()} Grupo waffle. Todos os direitos reservados.
              </p>
            </div>


            {/* Seção de Contato */}
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Para relatar erros técnicos, entre em contato <a href="https://app.thenewscc.com.br/support?newsletter=thenews" className="text-[#FF3366]">aqui</a>
              </p>
            </div>

            
          </div>
        </div>
      </footer>
    </>
  );
};

export { Footer };